export default __webpack_public_path__ + "static/media/12-1.443346cf.jpeg";